import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { FaRegMoon } from "react-icons/fa";
import { MdOutlineDashboard } from "react-icons/md";
import { FaRegBell } from "react-icons/fa";
import indianFlag from "../assets/india.png";
import userLogo from "../assets/user.png";
import { IoMailSharp } from "react-icons/io5";
import { RiAlertFill } from "react-icons/ri";
import { IoListOutline } from "react-icons/io5";
import { LuLogOut } from "react-icons/lu";
import { Navigate, useNavigate } from "react-router-dom";
import useAuth from "../useAuth";

export default function () {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmed = window.confirm("Are you sure you want to Log Out");
    if (!confirmed) return;
    logout();
  };
  return (
    <div className="flex items-center sticky top-0 z-40 justify-between gap-3 bg-white py-6 mx-4 border-b">
      <div className="flex justify-between w-full">
        <div className="flex justify-center gap-4 items-center text-gray-600 text-2xl">
          <img
            className="w-10 h-10 rounded-full object-cover select-none"
            src={userLogo}
            onClick={() => navigate("./profile")}
          />
          <div className="text-sm text-slate-900 mr-5 select-none">
            {user?.firstName} {user?.lastName}
          </div>

          {/* <IoMailSharp className="text-xl" /> */}
          {/* <RiAlertFill className="text-xl" /> */}
          {/* <IoListOutline className="text-xl" /> */}
        </div>
        <div className="flex hover:cursor-pointer justify-center gap-2 items-center text-slate-900 text-2xl">
          <div
            className="flex gap-3 uppercase font-bold text-xs cursor-pointer text-white hover:bg-red-700 border-2 bg-red-500 border-gray-500 p-2 rounded"
            onClick={handleLogout}
          >
            Log out
            <LuLogOut className="text-sm" />
          </div>
        </div>
      </div>
    </div>
  );
}
